export default "__VITE_ASSET__B4mG6Tun__"